import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import getDisplayName from 'react-display-name'
import { Helmet } from 'react-helmet'
import { Parent } from '@app/models/users'
import Headbar from '@app/components/shared/Headbar'
// import ProfileSubheader from '@app/components/shared/ProfileSubheader'
import { AbilityContext } from '@app/context/ability-context'
import { defineParentAbilities, authorize } from '@app/ability'
import _ from 'lodash'

class ParentLayout extends Component {
  render() {
    const Component = this.props.component
    const { parent, route, global } = this.props
    const ability = defineParentAbilities(parent, global)

    if ( !authorize(ability, Component) ) {
      return <Redirect to='/404' />
    }

    return (
      <div className="w-flex-layout layout layout--public">
        <Helmet>
          <title>{ I18n.t('layouts.parent.title') }</title>
        </Helmet>
        <div className="w-flex-layout__top">
          <Headbar
            global={global}
            user={parent}
            route={route}
          />
          {/*<ProfileSubheader event={global.event} />*/}
        </div>
        <div className="w-flex-layout__center">
          <AbilityContext.Provider value={ability}>
            <Component parent={parent} route={route} global={global} />
          </AbilityContext.Provider>
        </div>
        <div className="w-flex-layout__bottom" />
      </div>
    )
  }
}

ParentLayout.propTypes = {
  parent: PropTypes.instanceOf(Parent).isRequired,
  global: PropTypes.object.isRequired
}

export default ParentLayout
